import { api } from '../api';
import { links } from '../../../data/links';

export const photosApi = api.injectEndpoints({
  endpoints: build => ({
    getPhotos: build.query({
      query: token => ({
        url: links.photos,
        headers: { Authorization: `Bearer ${token}` },
      }),
      transformResponse: responseData => {
        const photosData = responseData?.data;

        if (photosData) {
          return photosData;
        } else {
          return [];
        }
      },
      providesTags: result =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Photos', id })),
              { type: 'Photos', id: 'LIST' },
            ]
          : [{ type: 'Photos', id: 'LIST' }],
    }),
    getPhotosForRealty: build.query({
      query: ({ token, realty_id }) => ({
        url: `${links.photos}/${realty_id}`,
        headers: { Authorization: `Bearer ${token}` },
      }),
      transformResponse: responseData => {
        const photosData = responseData?.data.photos;

        if (photosData) {
          return photosData;
        } else {
          return {};
        }
      },
      providesTags: [{ type: 'Photos', id: 'LIST' }],
    }),
    addPhotos: build.mutation({
      query({ token, realty_id, data }) {
        return {
          url: `${links.photos}/${realty_id}`,
          method: 'POST',
          body: data,
          headers: { Authorization: `Bearer ${token}` },
        };
      },
      invalidatesTags: (result, error, { realty_id }) =>
        !error
          ? [
              { type: 'Photos', id: 'LIST' },
              { type: 'RealtyPhotos', id: 'LIST' },
              { type: 'Realties', id: 'LIST' },
              { type: 'Realties', id: realty_id },
              { type: 'Reminders', id: 'LIST' },
            ]
          : [],
    }),
    updatePhotos: build.mutation({
      query({ token, realty_id, data }) {
        return {
          url: `${links.photos}/${realty_id}/update`,
          method: 'POST',
          body: data,
          headers: { Authorization: `Bearer ${token}` },
        };
      },
      invalidatesTags: (result, error, { realty_id }) =>
        !error
          ? [
              { type: 'Photos', id: 'LIST' },
              { type: 'Realties', id: 'LIST' },
              { type: 'Realties', id: realty_id },
              { type: 'Reminders', id: 'LIST' },
            ]
          : [],
    }),
    deletePhoto: build.mutation({
      query({ token, id }) {
        return {
          url: `${links.photos}/${id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${token}` },
        };
      },
      invalidatesTags: (result, error, { realty_id }) =>
        !error
          ? [
              { type: 'Photos', id: 'LIST' },
              { type: 'RealtyPhotos', id: 'LIST' },
              { type: 'Realties', id: 'LIST' },
              { type: 'Realties', id: realty_id },
              { type: 'Reminders', id: 'LIST' },
              { type: 'SearchRealties', id: realty_id },
              { type: 'SearchRealtiesMap', id: 'LIST' },
            ]
          : [],
    }),
    downloadPhotosForRealty: build.query({
      query: ({ token, realty_id }) => ({
        url: `${links.photos}/${realty_id}/download`,
        headers: { Authorization: `Bearer ${token}` },
      }),
    }),
  }),
});

export const {
  useGetPhotosQuery,
  useGetPhotosForRealtyQuery,
  useAddPhotosMutation,
  useUpdatePhotosMutation,
  useDeletePhotoMutation,
  useDownloadPhotosForRealtyQuery,
} = photosApi;
